<div class="custom-search-bar">
  <mat-icon>search</mat-icon>
  <input type="search" [(ngModel)]="text" [placeholder]="label()" class="custom-search-input" #input />

  @if (text()) {
    <button type="button" mat-icon-button (click)="text.set('')" matTextPrefix="" matTooltip="Suche leeren">
      <mat-icon>close</mat-icon>
    </button>
  }

  @if (showShortcut() && input) {
    <span matTextSuffix class="mat-body-large flex flex-gap-0">
      <kbd>Ctrl</kbd>
      <kbd>K</kbd>
    </span>
  }
</div>
